import { Button, TextBody, ButtonProps } from '@ally/metronome-ui';
import { Modal } from '../../molecules';
import styled from 'styled-components';
import { useState } from 'react';

const StyledButton = styled(Button)`
  ${({ theme: { colors } }): string => `
    color: ${colors['blue-800']};
  `}
`;
type IProps = {
  to: string;
  title?: string;
  modalBody?: React.FunctionComponentElement<any>;
} & Pick<ButtonProps, 'variant' | 'text'>;
const LeavingAllyModal: React.FC<IProps> = ({
  title = 'This is where we part ways',
  to,
  variant,
  text,
  modalBody,
}) => {
  const [open, setOpen] = useState(false);

  const handleRedirect = (url: string) => {
    setOpen(false);
    window.open(url, '_blank', 'noopener noreferrer');
  };

  const defaultModalBody = (
    <TextBody tag='p' size='sm'>
      <TextBody tag='span' weight='bold' size='sm'>
        You're leaving ally.com and heading to a third-party site we don't own
        or control.
      </TextBody>
      <br /> <br />
      FYI: That site has its own privacy policy and level of security. We
      suggest reviewing those policies and any terms and conditions on that
      site. Ready to go?
    </TextBody>
  );

  return (
    <Modal
      open={open}
      onOpenChange={setOpen}
      heading={title}
      headingProps={{ fontSize: '1.6rem', color: '#650360' }}
      content={modalBody ?? defaultModalBody}
      continue={() => handleRedirect(to)}
      cancel={() => setOpen(false)}
      trigger={
        <StyledButton
          variant={variant}
          text={text ?? ''}
          onClick={() => setOpen(true)}
        />
      }
      width='md'
    />
  );
};

export default LeavingAllyModal;
